export default "__VITE_ASSET__BVxe3gX___"